import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useHistory } from "react-router-dom";

import '../layout/sass/_pickListSugestoes.scss';
import { DialogRotas } from './DialogRotas';


import '../layout/sass/_responsiveTable.scss';


import api from '../api/api';


import { AuthContext } from '../contexts/AuthContext';
import { FilterContext } from '../contexts/FilterContext';

export const TabelaRotas = () => {
    const toast = useRef(null);
    const [rotas, setRotas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const [isShowInfo, setIsShowInfo] = useState(false);
    const [msgInfo, setMsgInfo] = useState([]);
    const [showListaRotas, setShowListaRotas] = useState(false);
    const { user } = useContext(AuthContext);
    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const { filter, setFilter } = useContext(FilterContext);

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Rotas</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="">
                <Button
                    label="Adicionar"
                    className="p-mb-2 p-button-primary"
                    icon="pi pi-plus"
                    iconPos="left"
                    type="button"

                    onClick={() => history.push('/rotascreate')}

                />
                </div>
            </div>
        </div>

    );

    const getRotas = useCallback(async (event) => {
        setIsLoading(true)
        setRotas([])



        if(event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;
                setFirst(startIndex);
            }, 250);
        }
        try {
            if(filter.filters === undefined) {
                if(event === undefined) {
                    const response = await api.get(`rotas?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })
                } else {
                    const response = await api.get(`rotas?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })

                }

                const respElements = await api.get(`rotas?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                const pesquisa = {
                    "rota": filter.filters['rota'] !== undefined ? filter.filters['rota'].value : '',
                }
                if(event === undefined) {
                    const response = await api.get(`rotas/search?searchTerm=${pesquisa.rota}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })
                    setTotalRecords(response.data.totalElements);
                } else {
                    const response = await api.get(`rotas/search?searchTerm=${pesquisa.rota}&page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })
                    setTotalRecords(response.data.totalElements);
                }
            }
        }
        catch (error) {

            if(filter !== undefined){
                if(event === undefined) {
                    const response = await api.get(`rotas?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })
                } else {
                    const response = await api.get(`rotas?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(rota => {
                        setRotas(rotas => [...rotas, rota])
                    })
                }

                const respElements = await api.get(`rotas?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter rotas', detail: error.toString() });
            }

        }

        setIsLoading(false)
    }, [filter, sortable, sortableCampo])

    useEffect(() => {
        const fetchRotas = async () => {
            try {
                await getRotas();

            }
            catch (error){
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchRotas();

    }, [getRotas])



    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-rounded p-mr-2 p-button-danger" loading={isDeleting} onClick={() => handleDeleteClick(rowData)}/>
            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const rotaBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Rota</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if(sortable === 'ASC'){
            setSortable('DESC')
        } else if (sortable == 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setFilter(event);
    }


    const handleEditClick = (data) => {
        history.push(`/rotas/edit/${data.id}`);
    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    await api.delete(`rotas/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Rota ${data.numero} removida com sucesso` });
                    getRotas()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a rota', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    return (
        <>
        <Dialog className='p-scrollpanel-bar-y' header="Histórico" onHide={() => setIsShowInfo(false)} visible={isShowInfo} breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{width: '50vw', heigth: '5vw'}} >
            {msgInfo.map((item) => {
                return (<p><li>{new Date(item.created_at).toLocaleString()} - {item.log}</li></p>)
            })}
        </Dialog>

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">


         <DialogRotas
                visible={showListaRotas}
                setVisible={setShowListaRotas}
                rota={rotas}
            />

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable
                        totalRecords={totalRecords}
                        lazy="true"
                        first={first}
                        onPage={getRotas}
                        ref={(element) => setDt(element)}
                        header={header}
                        value={rotas}
                        filterDisplay="row"
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma rota encontrada"
                        loading={isLoading}
                        dataKey="id"
                        paginator
                        rows={20}
                        currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} rotas`}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                        // rowsPerPageOptions={[10, 20, 30]}
                        onSort={onSort}
                        onFilter={onFilter}
                       filters={filter.filters}
                    >

                        <Column style={{ width: '12%' }}
                            field="id"
                            header="Código"
                            sortable={sortable}
                            body={codigoBodyTemplate}
                        />

                        <Column
                            field="rota"
                            header="Rota"
                            sortable={sortable}
                            body={rotaBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder={filter.filters !== undefined && (filter.filters.nome !== undefined && filter.filters.nome.value != null) ? filter.filters.nome.value : "Pesquisar pelo nome da rota"}
                        />

                        <Column
                            header="Ações"
                            body={actionBodyTemplate}
                        />

                    </DataTable>

                </div>
            </div>
        </div>

        </>
    );
}
